export const singaporePrimaryColor = "#babab9" // a gray a bit darker than from the merlion
export const singaporePrimaryColorDarker = "#9e9e9c" // 15% darker
